import { useEffect, useRef, useState, useCallback } from "react";
import { api } from "../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const WS_URL = BACKEND.replace(/^http/, "ws") + "/api/ws";

export function useAgentSocket() {
  const [state, setState] = useState(null);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const timerRef = useRef(null);
  const pollRef = useRef(null);
  const intentionalRef = useRef(false);
  const connectedRef = useRef(false);

  const connect = useCallback(() => {
    if (wsRef.current && (wsRef.current.readyState === 0 || wsRef.current.readyState === 1)) return;
    let ws;
    try {
      const tok = localStorage.getItem("smc_token");
      ws = new WebSocket(tok ? `${WS_URL}?token=${encodeURIComponent(tok)}` : WS_URL);
    } catch {
      timerRef.current = setTimeout(connect, 1500);
      return;
    }
    wsRef.current = ws;
    ws.onopen = () => {
      connectedRef.current = true;
      setConnected(true);
    };
    ws.onmessage = (e) => {
      try {
        setState(JSON.parse(e.data));
      } catch {}
    };
    ws.onclose = () => {
      connectedRef.current = false;
      setConnected(false);
      if (intentionalRef.current) return;
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(connect, 1500);
    };
    ws.onerror = () => {
      try {
        ws.close();
      } catch {}
    };
  }, []);

  useEffect(() => {
    intentionalRef.current = false;
    // instant first paint + resilient fallback via REST polling
    api.state().then(setState).catch(() => {});
    pollRef.current = setInterval(() => {
      if (!connectedRef.current) api.state().then(setState).catch(() => {});
    }, 1500);
    connect();
    return () => {
      intentionalRef.current = true;
      clearTimeout(timerRef.current);
      clearInterval(pollRef.current);
      if (wsRef.current) {
        try {
          wsRef.current.close();
        } catch {}
      }
    };
  }, [connect]);

  return { state, connected };
}
